import { AuthTokens } from '@/types'

const TOKEN_KEY = 'tlbh_auth_tokens'

class TokenStorage {
  setTokens(tokens: AuthTokens): void {
    try {
      localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens))
    } catch (error) {
      console.error('Failed to store tokens:', error)
    }
  }

  getTokens(): AuthTokens | null {
    try {
      const stored = localStorage.getItem(TOKEN_KEY)
      if (!stored) return null

      const tokens: AuthTokens = JSON.parse(stored)
      
      // Check if token is expired
      if (this.isTokenExpired(tokens)) {
        this.clearTokens()
        return null
      }

      return tokens
    } catch (error) {
      console.error('Failed to retrieve tokens:', error)
      this.clearTokens()
      return null
    }
  }

  clearTokens(): void {
    try {
      localStorage.removeItem(TOKEN_KEY)
    } catch (error) {
      console.error('Failed to clear tokens:', error)
    }
  }

  private isTokenExpired(tokens: AuthTokens): boolean {
    if (!tokens.expiresIn) return false
    
    // Get the timestamp when tokens were stored
    const stored = localStorage.getItem(TOKEN_KEY)
    if (!stored) return true

    try {
      const parsedTokens = JSON.parse(stored)
      const storedAt = parsedTokens.storedAt || Date.now()
      const expiresAt = storedAt + (tokens.expiresIn * 1000)
      
      // Add 5 minute buffer before expiry
      return Date.now() >= (expiresAt - 5 * 60 * 1000)
    } catch {
      return true
    }
  }

  // Store tokens with timestamp
  setTokensWithTimestamp(tokens: AuthTokens): void {
    try {
      const tokensWithTimestamp = {
        ...tokens,
        storedAt: Date.now()
      }
      localStorage.setItem(TOKEN_KEY, JSON.stringify(tokensWithTimestamp))
    } catch (error) {
      console.error('Failed to store tokens with timestamp:', error)
    }
  }
}

export const tokenStorage = new TokenStorage()